import React, { ReactElement } from "react";

import { TooltipProps } from "antd";

import { Tooltip, TooltipVariant } from "components";

type TooltipWrapperProps = {
  children: ReactElement;
  className?: string;
  tooltip?: Pick<TooltipProps, "placement" | "title"> | null;
  open?: boolean;
  mRef?: React.RefObject<HTMLSpanElement>;
  style?: React.CSSProperties;
  /** Forwarded so wrapped call sites can opt into the design-library look without reaching for Tooltip directly. */
  variant?: TooltipVariant;
};

export const TooltipWrapper = ({ children, tooltip, open, className, mRef, style, variant }: TooltipWrapperProps) =>
  tooltip ? (
    <Tooltip className={className} style={style} title={tooltip.title as string} placement={tooltip.placement} open={open} mRef={mRef} variant={variant}>
      {children}
    </Tooltip>
  ) : (
    children
  );

export default TooltipWrapper;
